/**
 * ICON COLOUR OPTIONS
 *    Ink Blue -- White | White & Pink | White & Aqua | White & Orange | White & Purple | White & Light Blue
 *    Mid Blue --  White
 *    All others -- Ink Blue | Ink Blue & Mid Blue
 */

import { isDevelopment } from '~/utils/misc'

export type IconProps = {
  icon: {
    image: Image
    duotone?: boolean
    accentColour?:
      | 'light-blue'
      | 'light-pink'
      | 'light-aqua'
      | 'light-orange'
      | 'light-purple'
  }
  backgroundColour?: AllBackgroundColours
  className?: string
}

const Icon = ({ icon, backgroundColour, className }: IconProps) => {
  const { image, duotone, accentColour } = icon
  let iconImage = image?.asset?.sys.uri

  const previewUrl =
    isDevelopment && !image?.asset.sys.uri.startsWith('https')
      ? 'https://preview-websitemodern-uni-hull.cloud.contensis.com'
      : ''

  if (backgroundColour === 'ink-blue' && duotone && accentColour) {
    iconImage = image?.asset?.sys.uri.replace(
      'single-colour/ink-blue',
      `duotone/white/${accentColour}`
    )
  } else if (['ink-blue', 'mid-blue'].includes(backgroundColour ?? '')) {
    iconImage = image.asset.sys.uri.replace('ink-blue', 'white')
  } else if (duotone) {
    iconImage = image.asset.sys.uri.replace(
      'single-colour/ink-blue',
      'duotone/ink-blue/mid-blue'
    )
  }

  return (
    <div className={className}>
      <img
        src={`${previewUrl}${iconImage}`}
        // alt={image?.altText}
        alt=''
        role='presentation'
      />
    </div>
  )
}

export default Icon
